import { registerBearerTokenGetter } from "@prismicio/editor-support/Http"

import { devToken } from "../constants"
import { env } from "../env"

export function setDevToken(token: string) {
  if (env.PAGE_BUILDER_AUTH_STRATEGY !== "token") return
  localStorage.setItem(devToken, token)
}

if (env.PAGE_BUILDER_AUTH_STRATEGY === "token")
  registerBearerTokenGetter(() => localStorage.getItem(devToken) ?? "")
